import React from 'react';

export const FloatingMoodboardBar = ({ displayMode, onDisplayModeChange, isVisible }) => {
    if (!isVisible) return null;

    return (
        <div className="fixed bottom-10 left-1/2 -translate-x-1/2 flex items-center justify-center z-50">
            <div className="bg-slate-800/90 backdrop-blur-sm border border-slate-700 text-slate-300 p-1.5 rounded-full shadow-lg pointer-events-auto flex items-center gap-1">
                <button
                    onClick={() => onDisplayModeChange('material')}
                    className={`px-6 py-2 rounded-full text-sm font-semibold transition-colors ${
                        displayMode === 'material' 
                        ? 'bg-slate-600 text-white' 
                        : 'text-slate-400 hover:bg-slate-700/50 hover:text-slate-200'
                    }`}
                >
                    Materials
                </button>
                <button
                    onClick={() => onDisplayModeChange('furniture')}
                    className={`px-6 py-2 rounded-full text-sm font-semibold transition-colors ${
                        displayMode === 'furniture'
                        ? 'bg-slate-600 text-white' 
                        : 'text-slate-400 hover:bg-slate-700/50 hover:text-slate-200'
                    }`}
                >
                    Furniture
                </button>
            </div>
        </div>
    );
};
